import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const TagIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.675 1.774a2.8 2.8 0 0 1 2.852 2.747v.127l-.145 5.457a2.24 2.24 0 0 1-.628 1.497L11.8 21.908a2.24 2.24 0 0 1-3.167.055l-6.177-5.965a2.24 2.24 0 0 1-.055-3.167l9.914-10.266a2.24 2.24 0 0 1 1.57-.683l5.79-.108Zm.026 1.4-5.79.107a.84.84 0 0 0-.588.257L3.409 13.804a.84.84 0 0 0 .02 1.187l6.178 5.965a.84.84 0 0 0 1.187-.02l9.953-10.306a.84.84 0 0 0 .235-.562l.145-5.457v-.064a1.4 1.4 0 0 0-1.426-1.373Zm-2.76 2.333a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2Zm0 1.306a.793.793 0 1 0 0 1.587.793.793 0 0 0 0-1.587Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default TagIcon;
